import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { bindActionCreators } from "redux";
import { fullName } from '../../../../../services';
import { businessActions, businessCurrentTeamMembersSelector, businessSelector } from '../../../../../state/modules/business';
import MultipleEntitiesTrainingPlans from '../partials/multi-entity-training-plans';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  teamMembersResult: businessCurrentTeamMembersSelector(state),
  isFetchingMembers: state.business.isFetchingMembers,
  taskStack: state.business.user.taskStack,
  setTrainingPlanSuccess: state.business.user.setBusinessUserTrainingPlanSuccess
})

const mapDispatchToProps = (dispatch) => ({
  getTeamMembers: bindActionCreators(businessActions.business.team.getTeamMembers, dispatch),
  loadMoreTeamMembers: bindActionCreators(businessActions.business.team.loadMoreMembers, dispatch),
  saveUserCpdCategorys: bindActionCreators(businessActions.business.user.setCpdCategorys, dispatch),
  initTaskStack: bindActionCreators(businessActions.business.user.initTaskStack, dispatch)
})

export const TeamMembersTrainingPlans = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    queryEntities: ({
      business,
      getTeamMembers,
      teamId
    }) => (filter) => {
      getTeamMembers(business.id, teamId, { ...filter, teamId: teamId })
    },
    loadMoreEntities: ({
      business,
      loadMoreTeamMembers,
      teamId
    }) => (filter) => {
      loadMoreTeamMembers(business.id, teamId, { ...filter, teamId: teamId })
    },
    saveCpdCategorys: ({
      business,
      saveUserCpdCategorys
    }) => (trainingPlan, entity, currentUserId, industryId, industryEntity, goals) => {
      const planToSave = fp.map(
        plan => ({
          ...plan,
          userId: entity.id
        })
      )(trainingPlan)
      saveUserCpdCategorys({
        cpdCategorys: planToSave,
        businessId: business.id,
        userId: entity.id,
        currentUserId: currentUserId,
        industryId: industryId,
        industry: industryEntity,
        goals
      })
    }
  }),
  withProps(
    ({
      teamMembersResult,
      isFetchingMembers
    }) => ({
      entityTrainingPlans: fp.flow(
        fp.get('teamMembers'),
        fp.map(
          ({ user, cpdCategorys, industryUser, goals }) => ({
            trainingPlan: cpdCategorys,
            entity: {
              ...user,
              name: he.decode(fullName(user))
            },
            goals: fp.map(
              ({ progressGoalId, points }) => ({
                goalId: progressGoalId,
                points
              })
            )(goals),
            industryEntity: industryUser
          })
        )
      )(teamMembersResult),
      entityQueryResult: teamMembersResult,
      isFetchingEntities: isFetchingMembers,
      headingCopy: (
        <Row className='no-gutter'>
          <Col>
            <p>Below is a breakdown of your team's training plans. You can update this and manage your team by editing this below</p>
          </Col>
        </Row>
      )
    })
  )
)(MultipleEntitiesTrainingPlans)


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/team-members-training-plans.js